var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Generalhandyman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "OJ6m37DXQLxWJQ1QzUa_Da",
    x1: 17.836,
    x2: 17.836,
    y1: -2306.473,
    y2: -2333.113,
    gradientTransform: "matrix(1 0 0 -1 -.88 -2286.123)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#OJ6m37DXQLxWJQ1QzUa_Da)",
    d: "M23.792,19.205l-0.672,0.672l-7,7L4.706,38.291c-0.781,0.781-0.781,2.047,0,2.828 l3.172,3.172c0.781,0.781,2.047,0.781,2.828,0l19.086-19.086L23.792,19.205z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "OJ6m37DXQLxWJQ1QzUa_Db",
    x1: 42.454,
    x2: 27.86,
    y1: 15.566,
    y2: 30.841,
    gradientTransform: "rotate(-45.001 21.497 23.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#OJ6m37DXQLxWJQ1QzUa_Db)",
    d: "M45.541,23.963l-8.485,8.485c-0.781,0.781-2.047,0.781-2.828,0L16.549,14.77 c-0.781-0.781-0.781-2.047,0-2.828l8.485-8.485c0.781-0.781,2.047-0.781,2.828,0l17.678,17.678 C46.322,21.915,46.322,23.181,45.541,23.963z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "OJ6m37DXQLxWJQ1QzUa_Dc",
    x1: 40.696,
    x2: 28.718,
    y1: 17.158,
    y2: 30.044,
    gradientTransform: "rotate(-45.001 21.497 23.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#OJ6m37DXQLxWJQ1QzUa_Dc)",
    d: "M32.813,8.406L32.813,8.406c-1.562,1.562-4.095,1.562-5.657,0l-3.536-3.536l-5.657,5.657 l3.536,3.536c1.562,1.562,1.562,4.095,0,5.657l0,0l7.778,7.778l0,0c1.562-1.562,4.095-1.562,5.657,0l3.536,3.536l5.657-5.657 l-3.536-3.536c-1.562-1.562-1.562-4.095,0-5.657l0,0L32.813,8.406z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Generalhandyman);
export default __webpack_public_path__ + "static/media/icons8-generalhandyman.c0bbc707a159422db37556d8dcf112c8.svg";
export { ForwardRef as ReactComponent };